/**
 * @используетсяВ: пока-что нигде
 *
 * @полезенПри: отслеживание высоты/ширины ноды
 *
 * Проверь возможности MutationObserver перед использованием этого.
 * Возможно MutationObserver будет лучшим решением.
 */

let tickInterval = 25;     //ms
let records = [];           //Соответствия watchingNode-watchingProperty-callback. При каждом вызове добавляется новый элемент массива
setInterval(()=> {
  records.forEach(record => {
    let currentPropVal = record.watchingNode[record.watchingProperty]
    if (currentPropVal !== record.lastPropertyVal){
      record.lastPropertyVal = currentPropVal
      record.cb();
    }
  })
}, tickInterval);

/**
 *
 * @param node, в дальнейшем, если понадобиться, можно сделать чтобы принимал и NodeList
 * @param prop  в дальнейшем, если понадобиться, можно сделать чтобы принимал и Array
 * @param cb
 */
function onNodePropertyChange(node, prop, cb) {
  records.push({
    watchingNode: node,
    watchingProperty: prop,
    cb: cb,
    lastPropertyVal: node[prop],
  });
}

export default onNodePropertyChange;



// WEBPACK FOOTER //
// ./src/JE/onNodePropertyChange.js